import { CitofoniaModule } from './modulos/citofonia/citofonia.module';
import { LoginComponent } from './modulos/autenticacion/login/login.component';
import { ROLES } from './modulos/componentes-compartidos/menu/items';
import { RolGuard } from './guards/rol.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';
import { MenuComponent } from './modulos/componentes-compartidos/menu/menu.component';
import { DetalleMiembroComponent } from './modulos/lugares/detalle-miembro/detalle-miembro.component';

const rutas: Routes = [
  {
    path: '',
    component: MenuComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'visitantes',
        loadChildren: () => import('./modulos/visitantes/visitantes.module').then( m => m.VisitantesModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR, ROLES.CELADOR] }
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./modulos/usuarios/usuarios.module').then( m => m.UsuariosModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR, ROLES.CELADOR] }
      },
      {
        path: 'lugares',
        loadChildren: () => import('./modulos/lugares/lugares.module').then( m => m.LugaresModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR] }
      },
      { path: 'apartamentos/:idApartamento/miembros/:idMiembro', component: DetalleMiembroComponent },
      {
        path: 'citofonia',
        loadChildren: () => import('./modulos/citofonia/citofonia.module').then( m => m.CitofoniaModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.CELADOR] }
      },
      {
        path: 'reservas',
        loadChildren: () => import('./modulos/reserva-espacios/reserva-espacios.module').then( m => m.ReservaEspaciosModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR] }
      },
      {
        path: 'areas',
        loadChildren: () => import('../app/modulos/areas/areas.module').then( m => m.AreasModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR] }
      },
      {
        path: 'pagos',
        loadChildren: () => import('../app/modulos/pagos/pagos.module').then( m => m.PagosModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR] }
      },
      {
        path: 'perfil',
        loadChildren: () => import('../app/modulos/perfil/perfil.module').then( m => m.PerfilModule)
      },
      {
        path: '',
        loadChildren: () => import('./modulos/lugares/lugares.module').then( m => m.LugaresModule),
        canActivate: [RolGuard],
        data: { roles: [ROLES.ADMINISTRADOR, ROLES.CELADOR] }
      },
    ]
  },
  {
    path: 'login',
    canActivate: [NoAuthGuard],
    component: LoginComponent
  },
  {
    path: 'nueva-contrasena/:token',
    canActivate: [NoAuthGuard],
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: 'lugares'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(rutas)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
